import { axiosInstance } from "../../../axios/axiosInstance";

const API_STAFF_URL = "organization/user-management";
const API_STAFF_MODULE_LIST_URL = API_STAFF_URL + "/list";
const API_CREATE_STAFF_MODULE_URL = API_STAFF_URL + "/create";
const API_UPDATE_STAFF_MODULE_URL = API_STAFF_URL + "/update";
const API_GET_STAFF_MODULE_BY_ID_URL = API_STAFF_URL + "/view";
const API_DELETE_STAFF_MODULE_URL = API_STAFF_URL + "/update-status";
const API_STAFF_RENEWAL_MODULE_URL = API_STAFF_URL + "/renew";

export const getStaff = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_STAFF_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${
      dataToBeSent?.limit || ""
    }&search=${dataToBeSent?.search || ""}&filters[status]=${dataToBeSent?.status || ""}`
  );
};

export const getStaffSelectList = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_STAFF_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${
      dataToBeSent?.limit || ""
    }&search=${dataToBeSent?.search || ""}`
  );
};

export const createStaff = (dataToBeSent) => {
  return axiosInstance.post(API_CREATE_STAFF_MODULE_URL, dataToBeSent);
};

export const updateStaff = (dataToBeSent) => {
  return axiosInstance.post(
    API_UPDATE_STAFF_MODULE_URL + "/" + dataToBeSent?._id,
    dataToBeSent
  );
};

export const getStaffById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_STAFF_MODULE_BY_ID_URL + "/" + dataToBeSent?.selectedStaffId
  );
};

export const deleteStaffById = (dataToBeSent) => {
  return axiosInstance.patch(
    API_DELETE_STAFF_MODULE_URL + "/" + dataToBeSent?.selectedStaffId,
    {
      status: "inactive",
    }
  );
};

export const renewStaff = (dataToBeSent) => {
  return axiosInstance.post(API_STAFF_RENEWAL_MODULE_URL, dataToBeSent);
};
